module.exports = __webpack_public_path__ + "9e0e686860661ba827a5c27d3241db96.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-ultralight-italic.woff
// module id = 81
// module chunks = 0